import { render, staticRenderFns } from "./SelectStaffs.vue?vue&type=template&id=0f79c839&scoped=true&"
import script from "./SelectStaffs.vue?vue&type=script&lang=js&"
export * from "./SelectStaffs.vue?vue&type=script&lang=js&"
import style0 from "./SelectStaffs.vue?vue&type=style&index=0&id=0f79c839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79c839",
  null
  
)

export default component.exports